// src/App.js
import React from 'react';
import './App.css';
import Experience from './Components/Experience';
import Certifications from './Components/Certifications';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
//import { CertificationBadge } from './Components/CertificationBadges';
//import LeftHead from './Components/left-head';
//import data from './data.json';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Hero from './Components/Hero';
import MatrixRain from './Components/MatrixRain';
import Navigation from './Components/Navigation';
import Contact from './Components/Contact';
import Footer from './Components/Footer';
import Skills from './Components/Skills';
import NotFound from './pages/NotFound';
//import { faUser, faEnvelope, faUsers, faMagnifyingGlass, faMagnifyingGlassChart, faTerminal, faServer,faCode, faGlobe, faToolbox, faGraduationCap, faCertificate } from '@fortawesome/free-solid-svg-icons';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

function Index() {
  return (
    <div className="min-h-screen bg-background text-foreground relative">
      {/* Matrix rain background */}
      <MatrixRain />
      
      {/* Navigation */}
      <Navigation />
      
      {/* Main content */}
      <main className="relative z-10">
        <Hero />
        <div className="section-divider" />
        <Skills />
        <div className="section-divider" />
        <Experience />
        <div className="section-divider" />
        <Certifications />
        <div className="section-divider" />
        <Contact />
      </main>
      
      {/* Footer */}
      <Footer />
    </div>
  );
}

//function Home() {
//  return (
//    <div className="App">
//      <div className="resume-container">
//        <LeftSection />
//        <RightSection />        
//      </div>
//    </div>
//  );
//}

//function LeftSection() {
//  return (
    
//      <div className="left-section">
//        <LeftHead />
//        <section className="summary">
//          <h3><FontAwesomeIcon icon={faUser} /> Summary</h3>
//          <p>{data.Summary}</p>
//        </section>
//        <Experience />
//      </div>
    
//  );
//}

//function RightSection() {
//  return (
//      <div className="right-section">
//        {/*<Skills />*/}
//        <section className="education">
//          <h3><FontAwesomeIcon icon={faGraduationCap} /> Education</h3>
//          <p>{data.Education[0]}</p>
//          <p>{data.Education[1]}</p>
//        </section>
//        <Certifications_Bak />
//        <CertificationBadge />
//      </div>
    
//  );
//}

//function Certifications_Bak() {
//  return (
//    <section className='certifications'>
//      <h3><FontAwesomeIcon icon={faCertificate} /> Certifications</h3>
//      <ul className="certifications-list">
//        {data.Certifications.map((item,index) => (
//          <li key={index}>{item}</li>
//        ))}
//    </ul>
//    </section>
//  )
//}

//const iconMapping = {
//  faTerminal: faTerminal,
//  faCode: faCode,
//  faMagnifyingGlass: faMagnifyingGlass,
//  faMagnifyingGlassChart: faMagnifyingGlassChart,
//  faUsers: faUsers,
//  faEnvelope: faEnvelope,
//  faServer: faServer,
//  faGlobe: faGlobe,
//};

//const Skills = () => {
//  return (
//    <section className="skills">
//      <h3>
//        <FontAwesomeIcon icon={faToolbox} /> Skills
//      </h3>
//      <ul className="skill-list">
//        {data.Skills.map((item, index) => (
//          <li key={index}>
//            <FontAwesomeIcon icon={iconMapping[item.icon]} /> {item.skill}
//          </li>
//        ))}
//      </ul>
//    </section>
//  );
//};

export default App;
